import './TicketLogoUploader.css';
import React, { useState } from 'react';
import classnames from 'classnames';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import GlobalProps from '../../../../../components/globalProps';
import { Icon } from '../../../../../components/Icon/Icon';
import { Logo } from '../../../../../model/logo';
import { Image } from '../../../../../model/asset';
import { t } from '../../../../../locales/translate';
import { LogoSelector } from './Modals/LogoSelector';

interface Props extends GlobalProps {
  logos: Logo[];
  label?: string;
  onChange?: (logos: Logo[]) => void;
}

export function TicketLogoUploader({ logos, label, onChange, style, className }: Props): JSX.Element {
  const [displayChooseModal, setDisplayChooseModal] = useState(false);

  function handleOnAddLogo(newLogos: Logo[]): void {
    if (onChange) {
      onChange([...logos, ...newLogos]);
      setDisplayChooseModal(false);
    }
  }

  function onRemove(index: number): void {
    if (onChange) {
      onChange(logos.filter((_, i: number) => i !== index));
    }
  }
  function onOrderChange(fromIndex: number, toIndex: number): void {
    const temp = [...logos];
    temp[fromIndex] = logos[toIndex];
    temp[toIndex] = logos[fromIndex];

    if (onChange) {
      onChange(temp);
    }
  }

  function DraggableImage({ image, index }: { image?: Image; index: number }): JSX.Element {
    if (image) {
      return (
        <Draggable key={'i-' + index} draggableId={'img' + index} index={index}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="draggable-tst"
            >
              {
                <div key={index} className="ticket-logo-uploader__wrapper">
                  <div className="ticket-logo-uploader__image" style={{ backgroundImage: `url(${image.url})` }} />
                  <div className="ticket-logo-uploader__hover-remove-button">
                    <div className="ticket-logo-uploader__remove-button" onClick={() => onRemove(index)}>
                      <Icon name="remove-circle--sm" />
                    </div>
                  </div>
                </div>
              }
            </div>
          )}
        </Draggable>
      );
    } else {
      return <div />;
    }
  }

  return (
    <div
      className={classnames('ticket-logo-uploader', { 'ticket-logo-uploader--product-images': logos }, className)}
      style={style}
    >
      <div className="ticket-logo-uploader__content">
        {label && <div className="ticket-logo-uploader__label">{label}</div>}
        <DragDropContext
          onDragEnd={(e) => {
            if (e.destination) {
              onOrderChange(e.source.index, e.destination.index);
            }
          }}
        >
          <Droppable droppableId="dropzone" direction="horizontal">
            {(provided) => (
              <div ref={provided.innerRef} className="ticket-logo-uploader__images">
                {logos.map((image, index) => (
                  <DraggableImage key={image.id} image={image && image.image} index={index} />
                ))}
                {provided.placeholder}
                <div className="ticket-logo-uploader__overlay">
                  <button
                    className="ticket-logo-uploader__button"
                    type="button"
                    onClick={() => setDisplayChooseModal(true)}
                  >
                    {t.actions.add(t.model.logo._name)}
                  </button>
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <LogoSelector
        open={displayChooseModal}
        onSelect={handleOnAddLogo}
        disabledLogos={logos}
        onClose={() => {
          setDisplayChooseModal(false);
        }}
      />
    </div>
  );
}
